import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { HubspotWorkflowView } from 'pages/hubspotWorkflows/ui/hubspotWorkflowView'
import { useHubspotWorkflowViewContext } from 'pages/hubspotWorkflows/ui/hubspotWorkflowView/context/context'

export const WorkflowView = observer(() => {
  const store = useHubspotWorkflowViewContext()

  useEffect(store.init, [store])

  return <HubspotWorkflowView />
})
